import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker'
import MobileDetect from '../vendor/mobile-detect.min'

window.md = new MobileDetect(window.navigator.userAgent)
window.jQuery(document).ready(function(){
  if (window.md.mobile()) {
    console.log('mobile device')
    window.jQuery('.date-picker').attr('type', 'date')
  } else {
    console.log('desktop')
    window.jQuery('.date-picker').datepicker({
      format: 'yyyy/mm/dd',
    });
  }
})